<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('suggestIndex')"><span>阳光互动</span></a> / <a href="javascript:void(0)" @click="urlTo('suggestList',{type:type})"><span>{{tabName}}一览</span></a> / <span>{{tabName}}详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <!-- <div style="margin-right: 60%;margin-left: 15%">
           <el-steps :active="active" finish-status="success">
             <el-step title="待受理"></el-step>
             <el-step title="受理中"></el-step>
             <el-step title="已受理"></el-step>
           </el-steps>
         </div>-->
        <div class="wraper">
          <div class="personal" style="width: 100%;">
            <div class="personal_right" style="width: 100%;">
              <el-card class="box-card" shadow="hover"
                       style="width: 100%;font-size: 14px;"
              >

                <h2 class="tit8"><span style="margin-left: 0px"><img src="../../../static/images/guide_sign4.png"> {{tabName}}详情</span>

               <!--   <span style="float: right;margin-right: 30px">
                       <el-tag v-if="detail.es_status!='2'"
                               type="danger"
                               effect="dark" style="width: 70px;height: 30px;line-height: 30px;font-size: 12px;text-align: center; padding: 0px;">
                    待处理
                  </el-tag>
                       <el-tag  v-if="detail.es_status=='2'"
                                effect="dark" style="width: 70px;height:30px;line-height: 30px;font-size: 12px;text-align: center;padding: 0px; ">
                    已回复
                  </el-tag>

                      </span>-->
                </h2>

                <div class="text detail" style="line-height: 40px; margin-left: 30px;margin-right: 30px;margin-top: 20px" >
                  <div style="display: flex;justify-content: left;" v-if="detail.s_catagory_name && detail.s_catagory_name!=''">
                    <div style="width:400px;"><span class="yy_title" style="font-size: 14px">{{tabName}}类别：</span><span class="yy_title_content" style="font-size: 14px">{{detail.s_catagory_name}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">{{tabName}}日期：</span><span class="yy_title_content"style="font-size: 14px">{{detail.lastTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">{{tabName}}标题：</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">{{tabName}}内容：</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="margin-top: 60px">
                    <el-divider content-position="left" v-if="detail.es_status=='2'" ><h2 class="el-icon-s-promotion" style="font-size: 16px;">办理回复</h2></el-divider>
                    <div style="display: flex;justify-content: left;margin-top: 30px;"  v-if="detail.es_status=='2'">
                      <div style="width:400px;"><span class="yy_title" style="font-size: 14px">受理单位：</span><span class="yy_title_content" style="font-size: 14px">{{detail.party_id}}</span></div>
                    </div>
                    <div style="display: flex;justify-content: left;"  v-if="detail.es_status=='2'">
                      <div ><span class="yy_title">回复时间：</span><span class="yy_title_content">{{detail.es_over_time}}</span></div>
                    </div>
                  </div>
                  <div style="display: flex;justify-content: left;" v-if="detail.es_status=='2'">
                    <div > <span class="yy_title" style="font-size: 14px">回复内容：</span><span class="yy_title_content" style="font-size: 14px">{{detail.es_remark}}</span></div>
                  </div>
                  <div style="height: 50px;width: 100%;"></div>
                </div>

              </el-card>
              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";

export default {
  name: "SuggestDetail",
  components: {
    headers, fixedDiv, footers
  },
  data() {
    return {
      detail: {},
      detail_id: '',
      html_url: '',
      active: 0,
      tabName: '投诉',
      type:'1',
    }
  },
  created() {
    this.detail_id = this.$route.query.detail_id;
    this.type=this.$route.query.type;
    this.getDetail();
  },
  methods: {
    //获取政策文件详细
    getDetail() {
      this.$https.post("/api/suggest/getAdviceById.do", {dataId: this.detail_id}, response => {
        if (response.status === 200 && response.data.code === 200) {
          this.detail = response.data.data;
          this.active =response.data.data.es_status;
          // this.html_url = process.env.API_HOST + '/' + this.detail.data_html_url;
          // console.log(this.html_url)
          this.tabName=response.data.data.s_type;
          $('#content').html(response.data.data.content)
        }
      });
    },
    //下载附件
    downloadAttach() {
      // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
      // });
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/suggest/SuggestDetail.vue